import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'input[fcpInput], textarea[fcpInput]',
    exportAs: 'fcpInput',
    host: {
        '[class.fcp-input]': 'true'
    },
    templateUrl: './fcp-input.component.html',
    styleUrls: ['./fcp-input.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FcpInputComponent {}
